import {arbitrum, base, bsc, linea, mainnet} from "viem/chains";
import {harmonyOne} from "wagmi/chains";
import {BridgeNetwork} from "./api/bridge";

export const HarmonyChainId = 1666600000

export enum appRoutes {
  // buy = 'buy',
  // AI = 'AI',
  swap = 'swap',
  // pools = 'pools',
  // lend = 'lend',
  bridge = 'bridge',
  explore = 'explore',
  dashboard = 'dashboard',
  send = 'send',
}

export const DefaultRoute = appRoutes.dashboard

export const AppRouteAlias = {
  [appRoutes.swap]: 'Swap',
  [appRoutes.dashboard]: 'Dashboard',
  [appRoutes.explore]: 'Explore',
  [appRoutes.send]: 'Send & Receive',
  [appRoutes.bridge]: 'Bridge',
}

export const BridgeNetworks = [mainnet, bsc, arbitrum, linea, base, harmonyOne]

export const BridgeNetworkMap: Record<number, BridgeNetwork> = {
  [arbitrum.id]: BridgeNetwork.ARBITRUM,
  [bsc.id]: BridgeNetwork.BINANCE,
  [mainnet.id]: BridgeNetwork.ETHEREUM,
  [base.id]: BridgeNetwork.BASE,
  [linea.id]: BridgeNetwork.LINEA,
  [harmonyOne.id]: BridgeNetwork.HARMONY,
}
